import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import classes from './AddPortAssignment.css';
import axios from '../../../../axios-local-api';
import Box from '../../../../hoc/Box/Box';
import Input from '../../../../components/UI/Input/Input';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler'
import {
  updateObject,
  checkValidity
} from '../../../../shared/utility';
import { FaInfoCircle } from 'react-icons/fa';


class AddPortAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adding: false,
      refreshLogs: false,
      extPorts: null,
      addForm: {
        name: {
          elementType: 'input',
          elementConfig: {
            id: 'AddPortName',
            type: 'text',
            placeholder: 'Assignment Name (3-20 characters)'
          },
          value: '',
          validation: {
            required: true,
            minLength: 3
          },
          valid: false,
          touched: false,
          label: 'Name'
        },
        externalPort: {
          elementType: 'input',
          elementConfig: {
            id: 'ExternalPort',
            type: 'text',
            placeholder: 'External Port (1-65535)'
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          label: 'External Port',
          errorLabel: ''
        },
        internalPort: {
          elementType: 'input',
          elementConfig: {
            id: 'InternalPort',
            type: 'text',
            placeholder: 'Internal Port (1-65535)'
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          label: 'Internal Port'
        },

        protocol: {
          elementType: 'select',
          elementConfig: {
            placeholder: '',
            type: 'text',
            placeholder: 'Protcol (udp, tcp)',
            options: [
              { value: 'tcp', displayValue: 'TCP' }, { value: 'udp', displayValue: 'UDP' }, { value: 'tcp+udp', displayValue: 'TCP+UDP' }
            ],
          },
          value: 'tcp',
          validation: {
            required: true
          },
          valid: true,
          touched: false,
          label: 'Protocol'
        }
      },
      formIsValid: false
    }
    //this.setExtPortsHandler = this.setExtPortsHandler.bind(this);
    this.inputChangedHandler = this.inputChangedHandler.bind(this);
  }

  inputChangedHandler(event, inputIdentifier) {
    var matchingPorts = [];
    var valid = checkValidity(event.target.value, this.state.addForm[inputIdentifier].validation);
    var errorLabel = '';
    if (inputIdentifier == 'externalPort' && valid) {

      this.props.usedExternalPorts.forEach((ports) => {
        ports.forEach(port => {
          if (port.externalPort == event.target.value) {
            matchingPorts.push(port);

          }
        });

      });
      valid = !(matchingPorts.length > 0);
      errorLabel = matchingPorts && matchingPorts.length ? 'This external port is already in use. Please enter an unique entry' : '';

    }

    var updatedFormElement = updateObject(this.state.addForm[inputIdentifier], {
      value: event.target.value,
      valid: valid,
      touched: true,
      errorLabel: errorLabel
    });

    const updatedAddPortAssignment = updateObject(this.state.addForm, {
      [inputIdentifier]: updatedFormElement
    });

    let formIsValid = true;
    for (let inputIdentifier in updatedAddPortAssignment) {
      formIsValid = updatedAddPortAssignment[inputIdentifier].valid && formIsValid;
    }
    this.setState({
      addForm: updatedAddPortAssignment,
      formIsValid: formIsValid,
      extPorts: matchingPorts
    });
  }
  isPortValid(port) {
    if (port.length < 1)
      return false;

    if (/^0/.test(port))
      return false;

    const reg = /^\d+$/;
    if (!reg.test(port))
      return false;

    let portNumber = parseInt(port)
    if (portNumber < 1)
      return false;

    if (portNumber > 65535)
      return false;

    return true;
  }
  isValidForm() {
    const nameValue = this.state.addForm.name.value || '';
    if (nameValue.trim().length <= 2)
      return false;

    if (nameValue.trim().length > 20)
      return false;
    if (!this.isPortValid(this.state.addForm.internalPort.value))
      return false;
    if (!this.isPortValid(this.state.addForm.externalPort.value))
      return false;


    return true;

  }


  addFormHandler = (event) => {
    const formVals = {
      name: this.state.addForm.name.value,
      internalPort: this.state.addForm.internalPort.value,
      externalPort: this.state.addForm.externalPort.value,
      protocol: this.state.addForm.protocol.value,
      originalPortAssignment: this.props.originalPortAssignment
    }
    this.props.onSubmit('assign a port for port forwarding', formVals, false);
    // this.props.onOpenModal('change this IP Reservation')

  }

  confirmModalCancelHandler = () => {
    this.props.onCancel();
  }

  render() {
    const formElementsArray = [];
    for (let key in this.state.addForm) {
      formElementsArray.push({
        id: key,
        config: this.state.addForm[key]
      });
    }
    let form = (
      <form onSubmit={this.addFormHandler}>
        {formElementsArray.map(formElement => (
          <Box>
            <div style={{ margin: '10px 0px -20px 10px', color: 'black' }}>{formElement.config.label}</div>
            <div className={classes.inputClass}>
              <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              <label style={{ color: 'red' }}>  {formElement.config.errorLabel} </label>
            </div>
          </Box>
        ))}
        <div style={{ color: 'black', margin: '10px', display: 'flex' }}>
          <span id ='addPortMsgIcon'><FaInfoCircle color="orange" /></span>
          <span id ='addPortMsg' style={{ marginLeft: '10px' }}>
            Change may take up to 2-10 minutes to occur on the customer router and public IP address may change. <b>During this time, the customer network may reboot.</b>
          </span>
        </div>

        <div style={{ margin: '20px 10px 10px 10px' }}>
          <button id="addportcancel" className={classes.CancelBtn} btnType="Success" onClick={this.confirmModalCancelHandler}>Cancel</button>
          <button id="addportsubmit" className={classes.SaveBtn} btnType="Success" disabled={(!this.isValidForm()) || (!this.state.formIsValid)}>Save</button>
        </div>
      </form>
    );
    if (this.props.loading) {
      form = <Spinner />;
    }
    return (
      <div className={classes.AddPortAssignment}>
        <span onClick={this.confirmModalCancelHandler} style={{ float: 'right', color: 'gray', cursor: 'pointer' }}>X</span>
        <h3 style={{ margineft: '10px', margin: '10px 0px 11px 10px' }}>Add Port Assignment</h3>
        {form}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    adding: false,
    refreshLogs: true
  }
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(AddPortAssignment, axios));
